export interface LanguageOption {
  code: string
  name: string
  nativeName: string
  badge: string
}

export const SUPPORTED_LANGUAGES: LanguageOption[] = [
  { code: 'en', name: 'English', nativeName: 'English', badge: 'EN' },
  { code: 'de', name: 'German', nativeName: 'Deutsch', badge: 'DE' },
  { code: 'fr', name: 'French', nativeName: 'Français', badge: 'FR' },
  { code: 'zh-CN', name: 'Chinese', nativeName: '中文', badge: 'ZH' },
  { code: 'it', name: 'Italian', nativeName: 'Italiano', badge: 'IT' },
  { code: 'nl', name: 'Dutch', nativeName: 'Nederlands', badge: 'NL' },
  { code: 'es', name: 'Spanish', nativeName: 'Español', badge: 'ES' },
]

export const LANGUAGE_EVENT = 'salzburg-language-changed'

function setCookie(name: string, value: string, days = 365) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString()
  const hostname = window.location.hostname

  document.cookie = `${name}=${value}; expires=${expires}; path=/;`

  if (hostname) {
    document.cookie = `${name}=${value}; expires=${expires}; path=/; domain=${hostname};`
    const parts = hostname.split('.')
    if (parts.length > 1) {
      const rootDomain = '.' + parts.slice(-2).join('.')
      document.cookie = `${name}=${value}; expires=${expires}; path=/; domain=${rootDomain};`
    }
  }
}

function clearCookie(name: string) {
  const epoch = 'Thu, 01 Jan 1970 00:00:00 UTC'
  const hostname = window.location.hostname

  document.cookie = `${name}=; expires=${epoch}; path=/;`
  if (hostname) {
    document.cookie = `${name}=; expires=${epoch}; path=/; domain=${hostname};`
    const parts = hostname.split('.')
    if (parts.length > 1) {
      const rootDomain = '.' + parts.slice(-2).join('.')
      document.cookie = `${name}=; expires=${epoch}; path=/; domain=${rootDomain};`
    }
  }
}

/**
 * Returns the currently active language code ('en', 'de', etc.)
 */
export function getCurrentLanguage(): string {
  if (typeof document === 'undefined') return 'en'

  const match = document.cookie.match(/(?:^|;\s*)googtrans=\/en\/([^;]+)/)
  if (match && match[1]) {
    return match[1]
  }

  const saved = localStorage.getItem('salzburg_language')
  if (saved) {
    return saved
  }

  return 'en'
}

/**
 * Changes language using Google Translate combo box and cookies.
 */
export function setLanguage(langCode: string): void {
  const targetCode = langCode === 'zh' ? 'zh-CN' : langCode

  try {
    localStorage.setItem('salzburg_language', targetCode)
  } catch {
    // Ignore storage issues
  }

  if (targetCode === 'en') {
    clearCookie('googtrans')
    setCookie('googtrans', '/en/en')
  } else {
    setCookie('googtrans', `/en/${targetCode}`)
  }

  // Notify UI subscribers immediately
  window.dispatchEvent(
    new CustomEvent(LANGUAGE_EVENT, { detail: { langCode: targetCode } })
  )

  // Trigger Google Translate combo element
  const select = document.querySelector<HTMLSelectElement>('.goog-te-combo')
  if (select) {
    select.value = targetCode === 'en' ? '' : targetCode
    select.dispatchEvent(new Event('change', { bubbles: true }))
  } else {
    // If Google translate script has not rendered combo yet, reload will pick up the cookie
    window.location.reload()
  }
}
